import { IconServer, IconRocket02, IconArrowLeft, IconArrowRight, IconCloud, IconNodepool, IconRunner } from 'components/Icons';
import { MenuItem } from 'modules/Sidebar/components/Menu/Menu';
import { BaseUserSettingsSidebar } from 'components/Sidebar/BaseUserSettingsSidebar';
import { useLocalStorage } from 'react-use';
import { cx, css } from '@linaria/core';
import { theming } from 'styles/utils';
import { CalloutBadge } from 'components/Badge/CalloutBadge';
import { useFeatureFlagsLD } from 'modules/FeatureFlagsLD/FeatureFlagsProviderLD';
const ComputeSidebarLinkList: React.FC = () => {
  const {
    enableLocalRunnersLDFF
  } = useFeatureFlagsLD();
  return <>
      <MenuItem href="/compute" icon={IconServer} className="menu-item">
        <span>Compute Overview</span>
      </MenuItem>
      <MenuItem href="/compute/clusters" icon={IconCloud} className="menu-item">
        <span>Clusters</span>
      </MenuItem>
      <MenuItem href="/compute/nodepools" icon={IconNodepool} className="menu-item">
        <span>Nodepools</span>
      </MenuItem>
      <MenuItem href="/compute/deployments" icon={IconRocket02} className="menu-item">
        <span>Deployments</span>
      </MenuItem>
      {enableLocalRunnersLDFF && <MenuItem href="/compute/runners" icon={IconRunner} className="menu-item">
          <span style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%'
      }}>
            Runners
            <CalloutBadge tight color="#344054" background="#fef0c7">
              NEW
            </CalloutBadge>
          </span>
        </MenuItem>}
    </>;
};
interface ComputeSidebarProps extends React.HTMLAttributes<HTMLDivElement> {
  onToggleCollapse?: (isCollapsed: boolean) => void;
}
export const ComputeSidebar: React.FC<ComputeSidebarProps> = ({
  className,
  onToggleCollapse,
  ...props
}) => {
  const [isCollapsed, setIsCollapsed] = useLocalStorage('compute-sidebar-collapsed', false);
  const handleToggleCollapse = () => {
    const newCollapsed = !isCollapsed;
    setIsCollapsed(newCollapsed);
    onToggleCollapse?.(newCollapsed);
  };
  return <BaseUserSettingsSidebar className={cx(computeSidebarWrapper, className)} data-collapsed={isCollapsed} {...props}>
      <div>
        <ComputeSidebarLinkList />
        <button type="button" className={collapseButton} onClick={handleToggleCollapse} data-testid="sidebar-collapse-btn">
          {isCollapsed ? <IconArrowRight size={12} /> : <IconArrowLeft size={12} />}
        </button>
      </div>
    </BaseUserSettingsSidebar>;
};
const COLLAPSED_SIDEBAR_WIDTH = '4.5rem';
const EXPANDED_SIDEBAR_WIDTH = '17.5rem';
const computeSidebarWrapper = "odules__Compute__Components__ComputeSidebar__ComputeSidebar_tsx-computeSidebarWrapper-ckdn6qu";
const collapseButton = "odules__Compute__Components__ComputeSidebar__ComputeSidebar_tsx-collapseButton-c1dm1grg";

require("./ComputeSidebar.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./ComputeSidebar.tsx");